import {
  ContentfulLivePreview,
  type LivePreviewProps
} from '@contentful/live-preview';
import { type InspectorModeTags } from '@contentful/live-preview/dist/inspectorMode/types';
export default defineNuxtPlugin({
  name: 'initContentfulLivePreview',
  async setup() {
    const {
      public: { isPreviewEnabled }
    } = useRuntimeConfig();
    ContentfulLivePreview.init({
      locale: 'de-DE',
      enableInspectorMode: isPreviewEnabled,
      enableLiveUpdates: isPreviewEnabled,
      debugMode: isPreviewEnabled,
      targetOrigin: 'https://app.contentful.com'
    });
    if (!isPreviewEnabled) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      ContentfulLivePreview.getProps = (props: LivePreviewProps) => {
        return {} as InspectorModeTags;
      };
    }
  },
  enforce: 'pre'
});
